import type { NavSection } from './navigation';

export function navItemKey(to: string): string {
  return `nav.item.${to.replace(/^\//, '').replace(/\//g, '.')}`;
}

export function navSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/&/g, ' ')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export function localiseSections(sections: readonly NavSection[], lookup: (key: string) => string | null): NavSection[] {
  return sections.map((section) => {
    const groupNames = new Map((section.groups ?? []).map((group) => [group.name, lookup(`nav.group.${navSlug(group.name)}`) ?? group.name]));
    return {
      ...section,
      title: lookup(`nav.section.${navSlug(section.title)}`) ?? section.title,
      groups: section.groups?.map((group) => ({ ...group, name: groupNames.get(group.name) ?? group.name })),
      items: section.items.map((item) => ({
        ...item,
        label: lookup(navItemKey(item.to)) ?? item.label,
        group: item.group ? groupNames.get(item.group) ?? item.group : undefined,
      })),
    };
  });
}
